/**
 * src/components/publico/PantallaPublica.jsx
 * El marco de las pantallas que se ven ANTES de entrar al panel: alta, acceso
 * y planes.
 *
 * Existe porque hasta ahora no había ninguno: cada una de esas pantallas se
 * dibujaba a sí misma y el visitante pasaba de una landing oscura a un
 * formulario gris claro de 400 px sin logo. El corte no era de gusto, era
 * literal — otro fondo, otra tipografía, otro radio de esquina.
 *
 * Los colores NO están aquí: los pone la clase `.cm-publico` de index.css
 * redefiniendo los tokens del panel. Este componente solo decide la estructura.
 */
import { Link } from 'react-router-dom'

/** La web pública. Quien llega aquí puede querer volver a leer antes de decidir. */
export const WEB_PUBLICA = 'https://cmmonitor.cl'

export function Isotipo({ tam = 32 }) {
  return (
    <img src="/isotipo-blanco.svg" alt="" width={tam} height={tam}
         style={{ display: 'block' }} />
  )
}

/** Isotipo + nombre. Enlaza a la web pública salvo que se pida lo contrario. */
export function Marca({ tam = 32, enlazado = true }) {
  const contenido = (
    <span style={{ display: 'inline-flex', alignItems: 'center', minHeight: '44px', gap: '10px' }}>
      <Isotipo tam={tam} />
      <span style={{ fontFamily: 'var(--font-brand)', fontSize: 'var(--text-lg)', fontWeight: 600, color: 'var(--color-text)' }}>
        CM Monitor
      </span>
    </span>
  )
  if (!enlazado) return contenido
  return <a href={WEB_PUBLICA} style={{ textDecoration: 'none' }}>{contenido}</a>
}

function FlechaIzquierda() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M19 12H5" />
      <path d="m12 19-7-7 7-7" />
    </svg>
  )
}

/** «← Volver a CM Monitor». Sin esto el alta es un callejón sin salida. */
export function VolverALaWeb({ texto = 'Volver a CM Monitor' }) {
  return (
    <a href={WEB_PUBLICA}
       style={{
         display: 'inline-flex', alignItems: 'center', gap: '7px',
         fontSize: 'var(--text-base)', color: 'var(--color-text-2)',
         textDecoration: 'none', padding: '12px 0', minHeight: '44px',
       }}
       onMouseEnter={e => { e.currentTarget.style.color = 'var(--color-text)' }}
       onMouseLeave={e => { e.currentTarget.style.color = 'var(--color-text-2)' }}>
      <FlechaIzquierda />
      {texto}
    </a>
  )
}

export function EnlaceSuave({ to, href, children, ...resto }) {
  // El dedo necesita 44 px; el texto de alrededor, no moverse.
  const estilo = { color: 'var(--color-accent-2)', textDecoration: 'none',
                   display: 'inline-block', padding: '12px 2px', margin: '-12px 0', }
  if (to) return <Link to={to} style={estilo} {...resto}>{children}</Link>
  return <a href={href} style={estilo} {...resto}>{children}</a>
}

/**
 * @param {'centrado'|'ancho'} disposicion  centrado = una columna (acceso);
 *   ancho = el contenido gestiona su propia rejilla (alta, planes).
 */
export function PantallaPublica({ children, disposicion = 'centrado', maxAncho = 1120 }) {
  return (
    <div className="cm-publico"
         style={{
           minHeight: '100vh', display: 'flex', flexDirection: 'column',
           padding: '24px clamp(20px, 5vw, 64px) 48px',
           boxSizing: 'border-box', fontFamily: 'var(--font-ui)',
         }}>

      <header style={{
        position: 'relative', zIndex: 1,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: 'var(--space-4)', width: '100%', maxWidth: `${maxAncho}px`, margin: '0 auto 8px',
        minHeight: '44px',
      }}>
        <Marca />
        <VolverALaWeb />
      </header>

      <main style={{
        position: 'relative', zIndex: 1,
        flexGrow: 1, width: '100%', maxWidth: `${maxAncho}px`, margin: '0 auto',
        display: 'flex', flexDirection: 'column',
        justifyContent: disposicion === 'centrado' ? 'center' : 'flex-start',
        paddingTop: disposicion === 'centrado' ? 0 : '28px',
      }}>
        {children}
      </main>
    </div>
  )
}
